import { useMemo } from 'react';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';

/**
 * @deprecated use usePetitionDetailsPageData() instead
 */
export function useFcm() {
	const {
		data: { featureConfigs },
	} = usePetitionDetailsPageData();
	return useMemo(
		() => ({
			status: 'loaded',
			values: featureConfigs,
		}),
		[featureConfigs],
	);
}

/**
 * @deprecated use usePetitionDetailsPageData() instead
 */
export const useSignFormFcm = useFcm;
